export default "__VITE_ASSET__a2dc6941__"